export const PORTAL_MODAL_SITE_WITHOUT_PROTECTION_ID = 'site-without-protection';

export const PORTAL_MODAL_SITE_WITHOUT_PROTECTION_NO_THREATS_ID = 'site-without-protection-no-threats';

export const PORTAL_MODAL_FEATURE_GATOR_PROTECT = 'gator-protect';

export const PORTAL_MODAL_SITELOCK_FREE_ACCEPT = 'site-lock-free-accept';
